// src/Component/former/Former.js
import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import './size.css'; // Import the CSS for styling

import size12 from '../../image/size12.png';
import size2 from '../../image/size2.png';

const Size = () => {
  return (
    <div className="details-container">

      {/* SEO Meta Tags */}
      <Helmet>
        <title>Size Press Paper Machine - Paper Sizing Machine in India</title>
        <meta
          name="description"
          content="Size Press Paper Machine. Paper Sizing Machine in India. P. Rakesh Industries offers advanced size press paper machines designed for superior surface sizing and sheet strength. Our surface size press machines, pond size press, and paper sizing machines in India ensure high efficiency, durability, and improved printing quality with pneumatic or hydraulic loading systems."
        />
        <meta property="og:title" content="Size Press Paper Machine - Paper Sizing Machine in India" />
        <meta
          property="og:description"
          content="Size Press Paper Machine. Paper Sizing Machine in India. P. Rakesh Industries offers advanced size press paper machines designed for superior surface sizing and sheet strength. Our surface size press machines, pond size press, and paper sizing machines in India ensure high efficiency, durability, and improved printing quality with pneumatic or hydraulic loading systems."
        />
        <meta property="og:url" content="https://pripapermachines.com/size-press-paper-machine" />
        <link rel="canonical" href="https://pripapermachines.com/size-press-paper-machine" />
      </Helmet>

      <div className="details-content">
        {/* Left Column */}
        <div className="column left">
          <div>
            <h1 style={{color:"#4d7544", textAlign:"left",fontSize:"34px"}}>SIZE PRESS PNEUMATIC LOADING</h1>
            <img src={size12} alt="Size Press Paper Machine" style={{height:"100%",width:"90%"}}/>
          </div>
        </div>

        {/* Right Column */}
        <div className="column right">
          <div className="column-right">
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <img src={size2} alt="Size Press Paper Machine" height="200px" />
            </div>
            <p style={{
              backgroundColor:" #4d7544",
              borderRadius:"10px",
              color:"white",
              padding:"20px",
              textAlign:"left"
            }}>
              Size press is used for surface sizing on paper or board. It mainly improves the sheet strength; this is important for multi-layer kraft paper and duplex board. sizing papers also have the advantage of improving the printing properties of paper and board, as well as reducing ink consumption and special colour effect. We offer size press with hydraulic or pneumatic loading systems as per the customer’s requirements.
            </p>
            <h1 style={{color:"#4d7544",textAlign:"left",fontSize:"26px"}}>Key Features:</h1>
            <ul style={{color:"black",textAlign:"left"}}>
              <li>High Sizing efficiency</li><br />
              <li>High operational reliability</li><br />
              <li>Small space demand</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Size;
